<template>
  <v-container fluid class="lighten-12 content">
    <v-data-table
              :fixed-header="true"
              :headers="trendingdish"
              :items="TopTrendingDish"
              item-key="id"
              hide-default-footer
            >
              <!-- Image -->
             
                <template v-slot:item.dish.image="{ item }">
                  <img
                    v-if="item.dish.image"
                    :src="item.dish.image"
                    height="32"
                    width="32"
                    class="image"
                  />
                  <v-avatar v-else size="32px" item color="primary">
                    <span class="white--text subtitle-2 text-uppercase">
                      {{ item.dish.name.substring(0, 2) }}</span
                    >
                  </v-avatar>
                </template>
            </v-data-table>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  name: "Home",

  data: () => ({
    trendingdish:[
       {
        value: "dish.image",
        show: true,
        disabled: true,

        width: "14%",
      },
      {
        text: "Code",
        value: "dish.code",
        align: "left",
        show: true,
        disabled: true,
        width: "14%",
      },
      {
        text: "Name",
        value: "dish.name",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
      {
        text: "Quantity",
        value: "quantity",
        show: true,
        align: "left",
        disabled: false,
        width: "14%",
      },
    ],

    TopTrendingDish:[],
  }),

  methods: {
      getTopTrendingDish() {
      axios
        .get(
          `hms/dash-board/top-ordered-dish`
        )
        .then((resp) => {
          this.TopTrendingDish = resp.data.data;
        })
        .catch((err) => {
          reject(err.response);
        });
    },

  },
  created() {
    this.getTopTrendingDish();
  },
};
</script>
<style scoped>
</style>
